var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVedio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 1.5L2.66667 1.5C2.22464 1.5 1.80072 1.67559 1.48816 1.98816C1.17559 2.30072 1 2.72464 1 3.16667L1 19.8333C1 20.2754 1.17559 20.6993 1.48816 21.0118C1.80072 21.3244 2.22464 21.5 2.66667 21.5L19.3333 21.5C19.7754 21.5 20.1993 21.3244 20.5118 21.0118C20.8244 20.6993 21 20.2754 21 19.8333L21 3.16667C21 2.72464 20.8244 2.30072 20.5118 1.98816C20.1993 1.67559 19.7754 1.5 19.3333 1.5Z",
    stroke: "url(#paint0_linear_2571_12621)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.5L21 6.5M16 1.5L12.6667 6.5M9.33333 1.5L6 6.5M9.05556 13.7222L9.05556 10.3544L11.9722 12.0378L14.8889 13.7222L11.9722 15.4061L9.05556 17.09V13.7222Z",
    stroke: "url(#paint1_linear_2571_12621)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2571_12621",
    x1: 1,
    y1: 1.5,
    x2: 21,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2571_12621",
    x1: 1,
    y1: 1.5,
    x2: 16.1185,
    y2: 20.8951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVedio);
export default __webpack_public_path__ + "static/media/vedio.648be13e9cc1e6855df53118d5eaaafa.svg";
export { ForwardRef as ReactComponent };